import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {FormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";
import {MatIconButton} from "@angular/material/button";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {DmsNewsItem} from "../../../../model/dmsNewsItem";
import {DmsNewsCommentItem} from "../../../../model/dmsNewsCommentItem";
import {DmsWfTasksService} from "../../../../services/api/dms-wf-tasks.service";
import {DmsTasksService} from "../../../../services/api/dms-tasks.service";
import {switchMap} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {tap} from "rxjs/operators";
import {EscapeAwareCharCountPipe} from "../../../../pipes/escape-aware-char-count.pipe";
import {EscapeAwareMaxLengthDirective} from "../../../../directives/escape-aware-max-length.directive";

@Component({
  selector: 'app-message-box-embedded',
  imports: [
    MatFormField,
    FormsModule,
    MatInput,
    NgIf,
    NgForOf,
    TranslateModule,
    MatLabel,
    MatHint,
    MatIcon,
    MatIconButton,
    NgClass,
    EscapeAwareCharCountPipe,
    EscapeAwareMaxLengthDirective
  ],
  templateUrl: './message-box-embedded.component.html',
  styleUrl: './message-box-embedded.component.scss',
  standalone: true
})
export class MessageBoxEmbeddedComponent {

  @Input() comments!: DmsNewsCommentItem[];
  @Input() type!: DmsNewsItem.TypeEnum | null;
  @Input() id!: number;

  @Output() messageUploadEvent = new EventEmitter<DmsNewsCommentItem[]>();

  sendCommentOnly: string =  '';

  isUplading: boolean = false;

  constructor(private dmsWfTasksService: DmsWfTasksService,
              private taskItemService: DmsTasksService,
              private tasksService: DmsTasksService,
              private workflowItemService: DmsWfTasksService,
              private _snackBar: MatSnackBar,
              private translate: TranslateService) {}

  getInitials(name: string){
    return name.substring(0,1)?.toUpperCase();
  }

  dateFormatting(timestamp: string | null, date?: boolean){
    if (timestamp && timestamp.length>1) {
      let dateArray = timestamp.split('T');
      dateArray[1] = dateArray[1].substring(0, 5);
      if (date) {
        return dateArray[0];
      } else {
        return dateArray.join(' ');
      }
    }
    else return '';
  }

  sendCommentRequest(){
    if(this.sendCommentOnly.length>0&&this.id&&this.type) {
      if (this.type === 'WfTask') {
        this.sendTaskCommentRequest();
      } else {
        this.sendWorkflowCommentRequest();
      }
    }
  }

  sendTaskCommentRequest() {
    if(this.sendCommentOnly.length>0) {
      this.dmsWfTasksService.createDmsWfTaskComment$(this.id, this.sendCommentOnly).pipe(
        tap(() => {
          this.isUplading = true;
          this.sendCommentOnly = '';
        }),
        switchMap(() => this.workflowItemService.readDmsWfTaskById$(this.id))
      ).subscribe({
        next: (response) => {
          if (response.result?.comments) {
            this.comments = [...response.result.comments];
            this.messageUploadEvent.emit(this.comments);
            this.isUplading = false;
          }
        },
        error: () => {
          this._snackBar.open(
            this.translate.instant('SOMETHING_WENT_WRONG'),
            this.translate.instant('OK'),
            { duration: 5000, panelClass: ['snackbar-warning'] }
          );
        }
      });
    }
  }

  sendWorkflowCommentRequest() {
    if(this.sendCommentOnly.length>0) {
      this.taskItemService.createDmsTaskComment$(this.id, this.sendCommentOnly).pipe(
        tap(() => {
          this.isUplading = true;
          this.sendCommentOnly = '';
        }),
        switchMap(() => this.taskItemService.readDmsTaskById$(this.id))
      ).subscribe({
        next: (response) => {
          if (response.result?.comments) {
            this.comments = [...response.result.comments];
            this.messageUploadEvent.emit(this.comments);
            this.isUplading = false;
          }
        },
        error: () => {
          this._snackBar.open(
            this.translate.instant('SOMETHING_WENT_WRONG'),
            this.translate.instant('OK'),
            { duration: 5000, panelClass: ['snackbar-warning'] }
          );
        }
      });
    }
  }

}
